
<template>
    <div class="animated fadeIn c-settings-panel">
        <b-row v-if="$router.currentRoute.name !== undefined" class="mb-2">
            <b-col>
                <b-button @click="gotoSupportMenu" class="btn btn-light pull-left"><i class="fa fa-chevron-left mr-2"></i>{{Core.Definition.getDefinition('Menu')}}</b-button>
                <h5 class="pull-left ml-3 mt-2">{{$router.currentRoute.name}}</h5>
                <div style="clear: both"></div>
                <hr/>
            </b-col>
            <b-col class="text-right">
                <b-button @click="onClickOpenTicket" class="btn btn-info">{{Core.Definition.getDefinition('Ouvrir un billet')}}</b-button>
            </b-col>
        </b-row>
        <div>
            <router-view></router-view>
        </div>
        <ModalSupport @="onTicketCreated" ref="modalSupport"></ModalSupport>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import ModalSupport from '../../components/ModalSupport'
    export default {
        name: 'SupportContainer',
        components: {
            ModalSupport
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        computed: {
        },
        methods: {
            gotoSupportMenu() {
                this.$router.push(Core.Definition.getDefinition('/systeme/support'))
            },
            onClickOpenTicket() {
                this.$refs.modalSupport.open = true
            },
            onTicketCreated() {
                this.$router.push(Core.Definition.getDefinition('/systeme/support/billets'))
            }
        }
    }
</script>
